/**
 * Authenticated contractor route with subscription gate + V3 shell.
 */

import { ReactNode } from 'react'
import ContractorRoute from './ContractorRoute'
import SubscriptionGuard from './SubscriptionGuard'
import V3Shell from '../shell/V3Shell'

interface ContractorAppRouteProps {
  children: ReactNode
}

export default function ContractorAppRoute({ children }: ContractorAppRouteProps) {
  return (
    <ContractorRoute>
      <SubscriptionGuard>
        <V3Shell>{children}</V3Shell>
      </SubscriptionGuard>
    </ContractorRoute>
  )
}
